export interface Division {
	title: string;
	description: string;
	color: string;
}

export interface Phase {
	id: number;
	title: string;
	short: string;
	description: string;
	divisions: Division[];
}

export interface TopData {
	phase: string;
	label: string;
	title: string;
	baseline: number;
	current: number;
	image: string;
}
export const topData: any[] = [
	{
		phase: 'Loading...',
		label: 'Loading...',
		title: 'Loading...',
		baseline: 0,
		current: 0,
		image: '/assets/img/balloon_1011.png',
	},
	{
		phase: 'Loading...',
		label: 'Loading...',
		title: 'Loading...',
		baseline: 0,
		current: 0,
		image: '/assets/img/balloon_1012.png',
	},
	{
		phase: 'Loading...',
		label: 'Loading...',
		title: 'Loading...',
		baseline: 0,
		current: 0,
		image: '/assets/img/balloon_1013.png',
	},
];

export const phases: Phase[] = [
	{
		id: 1011,
		title: 'Becoming a Reader',
		short: 'Phase I',
		description: 'Introduction to reading and basic literacy skills.',
		divisions: [
			{
				title: 'Emerging',
				description:
					'Students develop foundational print concepts, recognize uppercase and lowercase letters, identify the sounds of basic phonemes, and decode simple words with the phonemes learned.',
				color: 'color-1',
			},
			{
				title: 'Bronze',
				description:
					'Students identify the sounds of and decode with additional basic phonemes, spell basic decodable words, and read basic high-frequency words.',
				color: 'color-2',
			},
			{
				title: 'Silver',
				description:
					'Students read simple sentences, identify the sounds of and decode with advanced phonemes, and read a passage with fluency, accuracy, and comprehension.',
				color: 'color-3',
			},
			{
				title: 'Gold',
				description:
					'Students identify the sounds of and decode with all 44 phonemes, read additional high-frequency words, and spell advanced decodable words.',
				color: 'color-4',
			},
			{
				title: 'Platinum',
				description: 'Students read a second passage with fluency, accuracy, and comprehension.',
				color: 'color-5',
			},
		],
	},
	{
		id: 1012,
		title: 'Developing Fluency',
		short: 'Phase II',
		description: 'Building reading fluency and comprehension skills.',
		divisions: [
			{
				title: 'Emerging',
				description:
					'Students decode and spell words, read sentences with initial phoneme-grapheme relationships, read high-frequency words, and read a passage with accuracy, fluency, and comprehension.',
				color: 'color-1',
			},
			{
				title: 'Bronze',
				description:
					'Students decode and spell words, read sentences with additional phoneme-grapheme relationships, read, spell and understand words with affixes, and read a second passage with accuracy, fluency, and comprehension.',
				color: 'color-2',
			},
			{
				title: 'Silver',
				description:
					'Students decode and spell words, read sentences with more phoneme-grapheme relationships, read additional high-frequency words, and read a third passage with accuracy, fluency, and comprehension.',
				color: 'color-3',
			},
			{
				title: 'Gold',
				description:
					'Students decode and spell words, read sentences with another set of phoneme-grapheme relationships, read, spell and understand words with additional affixes, and read a fourth passage with accuracy, fluency, and comprehension.',
				color: 'color-4',
			},
			{
				title: 'Platinum',
				description:
					'Students decode and spell words, read sentences with a final set of phoneme-grapheme relationships, read additional high-frequency words, and read a fifth passage with accuracy, fluency, and comprehension.',
				color: 'color-5',
			},
		],
	},
	{
		id: 1013,
		title: 'Reading to Learn',
		short: 'Phase III',
		description: 'Using reading as a tool for learning and acquiring knowledge.',
		divisions: [
			{
				title: 'Emerging',
				description:
					'Students read a passage accurately, define key vocabulary, identify explicitly stated information, and make interpretations and basic inferences.',
				color: 'color-1',
			},
			{
				title: 'Bronze',
				description:
					'Students read a second passage accurately, define key vocabulary, identify explicitly stated information, and make interpretations and inferences.',
				color: 'color-2',
			},
			{
				title: 'Silver',
				description:
					'Students read a third passage accurately, define key vocabulary, identify explicitly stated information, and make interpretations and inferences.',
				color: 'color-3',
			},
			{
				title: 'Gold',
				description:
					'Students read a fourth passage accurately, define key vocabulary, identify explicitly stated information, and make interpretations and inferences.',
				color: 'color-4',
			},
			{
				title: 'Platinum',
				description:
					'Students read a fifth passage accurately, define key vocabulary, identify explicitly stated information, and make interpretations and inferences.',
				color: 'color-5',
			},
		],
	},
];
